import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png"
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <header className="header_3_header_block">
        <section>
          <div className="header_3_logo">
            <Link
              to="/"
              style={{ backgroundImage: `url(${logo})` }}
              ></Link>
          </div>
          <nav className={`header_3_main_nav ${isMenuOpen ? 'active' : ''}`}>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/play">How to play</Link>
              </li>
              <li>
                <Link to="/system">Balls System</Link>
              </li>
              <li>
                <Link to="/contacts">Contacts</Link>
              </li>
            </ul>
          </nav>
        </section>
        <button
          className="header_3_toggler"
          id="header_3_toggler"
          onClick={toggleMenu}
        >
          <span>
            <em></em>
            <em></em>
            <em></em>
          </span>
        </button>
      </header>
      
      <div></div>
    </div>
  );
};

export default Header;